/**
 * Activate sticky header bar
 */
export const initSticky = (md) => {
    //if (!md.phone() && !md.tablet()) {
        setTimeout(function(){$('.header-slider .swiper-slide__info ').removeClass('swiper-slide__info--hide');},750);
        $(window).scroll(makeSticky);
        makeSticky();
    //}
};

const makeSticky = () => {
    let gap = $('.header-slider').outerHeight() - $('.site-header').outerHeight() -100;
    let header = $('.site-header');
    let layout = $('body');
    let info = $('.header-slider .swiper-slide__info ');

    if ($(window).scrollTop() >= gap/3 ) {
        info.addClass('swiper-slide__info--hide');
    } else {
        info.removeClass('swiper-slide__info--hide');
    }

    if ($(window).scrollTop() >= gap /*.outerHeight()*/ ) {
        header.addClass('site-header--is-stuck');
        layout.addClass('is-stuck');
        $('.back-to-top').addClass('back-to-top--active');
    } else {
        header.removeClass('site-header--is-stuck');
        layout.removeClass('is-stuck');
        $('.back-to-top').removeClass('back-to-top--active');
    }
};